/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Missing_In_Out_ToastInputs */

const en_audio_description_missing_in_out_toast = /** @type {(inputs: Audio_Description_Missing_In_Out_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In and Out times of Event not set.`)
};

const fr_audio_description_missing_in_out_toast = /** @type {(inputs: Audio_Description_Missing_In_Out_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les temps d'entree et de sortie de l'evenement ne sont pas definis.`)
};

const de_audio_description_missing_in_out_toast = /** @type {(inputs: Audio_Description_Missing_In_Out_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eintritts- und Austrittszeiten der Veranstaltung nicht festgelegt.`)
};

const it_audio_description_missing_in_out_toast = /** @type {(inputs: Audio_Description_Missing_In_Out_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gli orari di entrata e uscita dell'evento non sono impostati.`)
};

const ru_audio_description_missing_in_out_toast = /** @type {(inputs: Audio_Description_Missing_In_Out_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время входа и выхода события не задано.`)
};

const es_audio_description_missing_in_out_toast = /** @type {(inputs: Audio_Description_Missing_In_Out_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horas de entrada y salida del evento no establecidas.`)
};

const zh_cn2_audio_description_missing_in_out_toast = /** @type {(inputs: Audio_Description_Missing_In_Out_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件的开始和结束时间未设置。`)
};

const ja_audio_description_missing_in_out_toast = /** @type {(inputs: Audio_Description_Missing_In_Out_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントの開始時間と終了時間が設定されていません。`)
};

const hi_audio_description_missing_in_out_toast = /** @type {(inputs: Audio_Description_Missing_In_Out_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्यक्रम के शुरू और खत्म होने का समय निर्धारित नहीं है।`)
};

const pt_pt2_audio_description_missing_in_out_toast = /** @type {(inputs: Audio_Description_Missing_In_Out_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horários de entrada e saída do evento não definidos.`)
};

/**
* | output |
* | --- |
* | "In and Out times of Event not set." |
*
* @param {Audio_Description_Missing_In_Out_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_missing_in_out_toast = /** @type {((inputs?: Audio_Description_Missing_In_Out_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Missing_In_Out_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_missing_in_out_toast(inputs)
	if (locale === "de") return de_audio_description_missing_in_out_toast(inputs)
	if (locale === "it") return it_audio_description_missing_in_out_toast(inputs)
	if (locale === "ru") return ru_audio_description_missing_in_out_toast(inputs)
	if (locale === "es") return es_audio_description_missing_in_out_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_missing_in_out_toast(inputs)
	if (locale === "ja") return ja_audio_description_missing_in_out_toast(inputs)
	if (locale === "hi") return hi_audio_description_missing_in_out_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_missing_in_out_toast(inputs)
	return en_audio_description_missing_in_out_toast(inputs)
});